
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cruises/articles/[id]",
      function () {
        return require("private-next-pages/cruises/articles/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cruises/articles/[id]"])
      });
    }
  